<template lang="pug">
  .action-button(@click="handleClick" :class="buttonType" :style="buttonWidth")
    highlightText.main-txt(
      :text='content'
      :normalStyle="btnNormalStyle"
      :highlightStyle="btnHighlightStyle"
    )
    .sub-text(v-if="subContent") {{subContent}}
</template>

<script>
import highlightText from '@/components/highlight-text.vue';

export default {
  name: 'ActionButton',
  components: {
    highlightText,
  },
  props: {
    content: {
      type: String,
      default: '',
    },
    subContent: {
      type: String,
      default: '',
    },
    buttonType: {
      type: String,
      default: 'normal', // normal, active
    },
    width: {
      type: String,
      default: '1.45rem',
    },
  },
  computed: {
    buttonWidth() {
      return `--btn-width: ${this.width}`;
    },
    btnNormalStyle() {
      return {
        color: '#fff',
        fontSize: '0.14rem',
      };
    },
    btnHighlightStyle() {
      return {
        color: '#fff',
        fontSize: '0.19rem',
        fontFamily: 'DINAlternate',
      };
    },
  },
  methods: {
    handleClick() {
      this.$emit('click');
    },
  },
};
</script>

<style lang="less" scoped>
.action-button {
  &.normal {
    width: var(--btn-width);
    height: 0.48rem;
    border-radius: 0.48rem;
    box-shadow: 0 1px 0.03rem 0 rgba(0, 0, 0, 0.12);
    background-color: #08f;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-right: 0.14rem;

    .main-txt {
      font-size: 0.14rem;
      height: 0.2rem;
      line-height: 0.2rem;
      font-weight: 500;
      text-align: center;
      color: #fff;
    }

    .sub-text {
      font-size: 0.1rem;
      height: 0.12rem;
      line-height: 0.12rem;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.7);
      text-align: center;
      text-decoration: line-through;
    }
  }

  &.active {
    border: 1px solid #f72e39;
    width: var(--btn-width);
    height: 0.48rem;
    border-radius: 0.48rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    background:
      linear-gradient(
        106.2deg,
        #ff41b9 -29.76%,
        #ff3c70 20.55%,
        #ff4c31 77.01%,
        #ffba43 109.99%
      );

    .main-txt {
      color: #fffae8;
      text-align: center;
      font-weight: 600;
      font-size: 0.14rem;
    }

    .sub-text {
      font-size: 0.1rem;
      height: 0.12rem;
      line-height: 0.12rem;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.7);
      text-align: center;
    }
  }
}
</style>
